import { AutogenLayoutDivisionCodeList } from "./autogen/AutogenLayoutDivisionCodeList";

export class DivisionCodeList extends AutogenLayoutDivisionCodeList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [{ field: "descr", sort: "asc" }];
    }
}
